// extracted by mini-css-extract-plugin
module.exports = {"root":"Text_root__Zab6T"};